var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9212 10.9751L22.4672 1.41614L21.053 0L11.507 9.55893L1.96109 0L0.546876 1.41614L10.0928 10.9751L0.546875 20.534L1.96109 21.9501L11.507 12.3912L21.053 21.9501L22.4672 20.534L12.9212 10.9751Z","fill":"white"}));
}

Close.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = Close;

Close.default = Close;
